import {Stack} from '@mui/material';
import ModuleViewActions from './ModuleViewActions';

export interface ModuleViewTopicsHeaderProps {
  onShuffleQuestions: () => void;
  onValidateAllQuestions: () => void;
  onValidateAllQuestionsGpt: () => void;
  onGenerateAllTopics: () => void;
  onGenerateWithSeedQuestion: () => void;
  onGenerateAllStudies: () => void;
  onCountQuestions: () => void;
  onBulkChangeStatus: () => void;
  shuffleLoading: boolean;
  validateLoading: boolean;
  validateGptLoading: boolean;
  generateAllLoading: boolean;
  generateWithSeedLoading: boolean;
  generateStudiesLoading: boolean;
  countLoading: boolean;
  bulkChangeLoading: boolean;
}

export default function ModuleViewTopicsHeader({
  onShuffleQuestions,
  onValidateAllQuestions,
  onValidateAllQuestionsGpt,
  onGenerateAllTopics,
  onGenerateWithSeedQuestion,
  onGenerateAllStudies,
  onCountQuestions,
  onBulkChangeStatus,
  shuffleLoading,
  validateLoading,
  validateGptLoading,
  generateAllLoading,
  generateWithSeedLoading,
  generateStudiesLoading,
  countLoading,
  bulkChangeLoading,
}: ModuleViewTopicsHeaderProps) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2} sx={{mb: 2}}>
      <ModuleViewActions
        onShuffleQuestions={onShuffleQuestions}
        onValidateAllQuestions={onValidateAllQuestions}
        onValidateAllQuestionsGpt={onValidateAllQuestionsGpt}
        onGenerateAllTopics={onGenerateAllTopics}
        onGenerateWithSeedQuestion={onGenerateWithSeedQuestion}
        onGenerateAllStudies={onGenerateAllStudies}
        onCountQuestions={onCountQuestions}
        onBulkChangeStatus={onBulkChangeStatus}
        shuffleLoading={shuffleLoading}
        validateLoading={validateLoading}
        validateGptLoading={validateGptLoading}
        generateAllLoading={generateAllLoading}
        generateWithSeedLoading={generateWithSeedLoading}
        generateStudiesLoading={generateStudiesLoading}
        countLoading={countLoading}
        bulkChangeLoading={bulkChangeLoading}
      />
    </Stack>
  );
}
